// PEOPLE-ALIGN 2026-07-03 (Part 3): promoted from the Grid|List toggle inline in
// TeeUpsNd/Tabs/index.tsx (wave4-fix6, Ale's .seg treatment) to a shared, option-count-agnostic
// component. Inbox uses it for 2 options (Grid|List); People reuses the identical component/
// classes for 4 (List|Grid|Network|Map) -- same seg-control pattern, literal reuse not a
// look-alike.
export interface SegToggleOption<T extends string> {
  value: T
  label: string
  testId?: string
}

interface SegToggleProps<T extends string> {
  options: SegToggleOption<T>[]
  value: T
  onChange: (value: T) => void
  testId?: string
}

const SegToggle = <T extends string,>({
  options,
  value,
  onChange,
  testId,
}: SegToggleProps<T>) => (
  <div
    className="inline-flex gap-1 rounded-full border border-[#E6EBF3] bg-white p-[3px]"
    data-testid={testId}>
    {options.map(opt => (
      <button
        key={opt.value}
        type="button"
        data-testid={opt.testId}
        className={
          "rounded-full px-4 py-[6px] text-[13px] font-medium transition-all " +
          (value === opt.value
            ? "bg-[#161A22] text-white"
            : "text-[#586173] hover:bg-[#EFF3F9]")
        }
        onClick={() => onChange(opt.value)}>
        {opt.label}
      </button>
    ))}
  </div>
)

export default SegToggle
